import React, { Component } from "react";
import { invokeApig } from "../../libs/awsLib";
import { 
    Col, 
    Button, 
    Modal,
    Glyphicon,
    Tooltip, 
    OverlayTrigger  
    } from "react-bootstrap";
import LoaderButton from "../../components/LoaderButton";
import NewAlert from "./NewAlert";

export default class AlertActions extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            isDeleting: false,
            show: false,
            alert:[]
        };
      
        this.handleClose = this.handleClose.bind(this);

    }

    handleClose() {
        this.setState({ show: false });
    }
    
    saveAlert(alert) {
        return invokeApig({
          path: `/alert/${this.props.alertId}`,
          method: "PUT",
          body: alert
        });
    }

    showConfirmDelete = () => {
    	this.setState({ show: true });
    }
    
    deleteAlert() {
        return invokeApig({
          path: `/alert/${this.props.alertId}`,
          method: "DELETE"
        });
    }

    handleDelete = async event => {
        event.preventDefault();

        this.setState({ isDeleting: true });

        try {
            await this.deleteAlert();
    //          this.props.history.push("/alert");
            this.setState({ isDeleting: false, show: false });
            this.props.onAlertSuccess({ message: "Alerta eliminada correctamente!" });
        } catch (e) {
            this.setState({ isDeleting: false, show: false });
            this.props.onAlertError({ message: "Error al eliminar alerta!" });
        }
    }

  handleAlertSuccess = (message) => {
	this.props.onAlertSuccess(message);
  }
  handleAlertError = (message) => {
    this.props.onAlertError(message);
  }

  render(){
    const tooltipDelete = (<Tooltip id="tooltipDelete"><strong>Eliminar</strong></Tooltip>);

    return(
        <div className="col-lg col-12">
            <Col lg={6}><NewAlert {...this.props} alertId={this.props.alertId} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/></Col>
            <Col lg={6}>
                <center>
                    <OverlayTrigger placement="top" overlay={tooltipDelete}>  
                    <Button onClick={this.showConfirmDelete} >
                        <Glyphicon glyph="trash" />
                    </Button>
                    </OverlayTrigger>  
                    <Modal show={this.state.show} onHide={this.handleClose}>
                        <Modal.Header closeButton>
                        <Modal.Title>Eliminar alerta</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>¿Está seguro que quiere eliminar la alerta?</Modal.Body>
                        <Modal.Footer>
                        <LoaderButton bsStyle="primary" isLoading={this.state.isDeleting} onClick={this.handleDelete} text="Eliminar" loadingText="Eliminando…"/>
                        <Button onClick={this.handleClose}>Cancelar</Button>
                        </Modal.Footer>
                    </Modal>
                </center>
            </Col>
        </div>
    );
  }
}




















// WEBPACK FOOTER //
// ./src/containers/alert/AlertActions.js